import { GraphDto } from "@custom-types/graphs"
import { RunGroupFormValues } from "@features/run/RunGroupDialog/RunGroupForm"
import { getDefaultValues as getRunModelFormDefaultValues } from "@features/run/RunModelForm/helpers"
import { parseISO } from "date-fns"
import { ContractFamilyInfo } from "@store/authAtoms"

export { getEligibleWhatIfContractOptions } from "@features/run/RunModelForm/helpers" // re-export common modules

export const getDefaultValues = (
  graph: GraphDto,
  contractOptions: ContractFamilyInfo[],
): RunGroupFormValues => {
  return {
    ...getRunModelFormDefaultValues(contractOptions), // extend RunModelForm fields
    description: "",
    start_date: graph.start_date === "rolling" ? "rolling" : parseISO(graph.start_date), // read only
    end_date: graph.end_date === "rolling" ? "rolling" : parseISO(graph.end_date),
    scenarios: [],
    contract_key:
      contractOptions?.length == 1
        ? // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
          contractOptions[0].contract_key
        : contractOptions?.length == 0 && graph?.owner_group_key === "private"
        ? "private" // if no contract option and the graph is a private graph, create a private run group
        : null,
    validate: false,
    linked_graph_mode: "MERGE",
  }
}

function parseGraphKey(key: string): { family: string; version: string } | null {
  const underscoreIdx = key.lastIndexOf("_")
  if (underscoreIdx === -1) return null
  return {
    family: key.slice(0, underscoreIdx + 1),
    version: key.slice(underscoreIdx + 1),
  }
}

function compareSemver(a: string, b: string): number {
  const aParts = a.split(".").map(Number)
  const bParts = b.split(".").map(Number)
  for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
    const diff = (aParts[i] ?? 0) - (bParts[i] ?? 0)
    if (diff !== 0) return diff
  }
  return 0
}

/**
 * Returns true when baseGraphKey (previous run) is compatible with graphKey (current graph):
 * - same family prefix
 * - previous run version ≤ current graph version
 */
export function isBaseGraphKeyCompatible(
  baseGraphKey: string | undefined,
  graphKey: string | undefined,
): boolean {
  if (!baseGraphKey || !graphKey) return false
  const base = parseGraphKey(baseGraphKey)
  const current = parseGraphKey(graphKey)
  if (!base || !current) return false
  if (base.family !== current.family) return false
  return compareSemver(base.version, current.version) <= 0
}
